import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection as collectionO,
  Firestore,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { env } from "../const";

const firebaseConfig = {
  apiKey: "AIzaSyBIPtoR45AMXSlodMfLGQiCJZiCLhl9GIo",
  authDomain: "werbinich-ec7f6.firebaseapp.com",
  projectId: "werbinich-ec7f6",
  storageBucket: "werbinich-ec7f6.appspot.com",
  messagingSenderId: "112485967698",
  appId: "1:112485967698:web:0d997d9e6236e1b3487c8b",
  measurementId: "G-TX5Y40G0BH"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const firestore = getFirestore();
export const auth = getAuth(app);

export const collection = (firestore: Firestore, path: string[]) =>
  collectionO(firestore, "envs", env, ...path);
export const getRef = (path: string[]) => ["envs", env, ...path].join("/");
